// @ts-strict-ignore
import { BASE_URL } from '@/shared/lib/const/env'
import { Col, Row } from '@/shared/ui/Grid'
import { Image } from '@/shared/ui/Image'
import { Title } from '@/shared/ui/Typography'
import { TitleLevels } from '@/shared/ui/Typography/Title/Title'

import { ArticleBottomDescription } from './ui/ArticleBottomDescription/ArticleBottomDescription'
import { ArticleTerms } from './ui/ArticleTerms/ArticleTerms'

import styles from './Article.module.scss'

export type TArticle = {
	NAME?: string
	ID: string
	DETAIL_TEXT?: string
	DETAIL_PICTURE?: string
	TERMS_PROMOTION?: string
	TITLE_TERMS_PROMOTION?: string
	HOW_GET_BENEFIT?: []
	PRODUCTS?: [] | null
	ACTIVE_FROM?: string | null
	ACTIVE_TO?: string
	ACTIVE?: string
}

export const Article = ({
	NAME,
	DETAIL_PICTURE,
	DETAIL_TEXT,
	ACTIVE_TO,
	TERMS_PROMOTION,
	TITLE_TERMS_PROMOTION
}: TArticle): JSX.Element => (
	<section className={styles.article}>
		{/* Title */}
		<Title bottomOffset="4x" level={`${TitleLevels.H1}`}>
			{NAME}
		</Title>

		{!!DETAIL_PICTURE && (
			<div className={styles.banner}>
				<div style={{ position: 'relative', width: '100%', aspectRatio: '1440 / 713' }}>
					<Image alt={NAME} src={BASE_URL + DETAIL_PICTURE} fill style={{ objectFit: 'cover' }} />
				</div>
			</div>
		)}

		{/* Detailed promotion info */}
		<div className={styles.content}>
			<Row justify="space-between">
				{/* Terms and steps of the promotion */}
				<Col span={18} xs={24} className={styles.contentCol}>
					<ArticleTerms ACTIVE_TO={ACTIVE_TO} description={DETAIL_TEXT} />
				</Col>
				<Col xl={6} xs={0} />

				{TERMS_PROMOTION && TITLE_TERMS_PROMOTION && (
					<Col span={24}>
						<ArticleBottomDescription description={TERMS_PROMOTION} title={TITLE_TERMS_PROMOTION} />
					</Col>
				)}
			</Row>
		</div>
	</section>
)
